export enum SkeletonVariant {
  RECTANGULAR = 'RECTANGULAR',
  CIRCULAR = 'CIRCULAR',
}

export enum SkeletonAnimation {
  WAVE = 'WAVE',
  PULSE = 'PULSE',
}
